{
	"ariaCheckAll": "Check All",
	"ariaCheckNone": "Check None",
	"ariaConfirmEditSelection": "Confirm Edit Selection",
	"checkAll": "Check all",
	"checkNone": "Check none",
	"colorTag": "Color Tag",
	"editSelected": "Edit Selected ({{count}})",
	"flag": "Flag",
	"selectedPhotosDescription_one": "{{count}} selected photo will be processed by AI automatically, and remaining photos will be hidden.",
	"selectedPhotosDescription_other": "{{count}} selected photos will be processed by AI automatically, and remaining photos will be hidden.",
	"smartCulling": "Smart Culling",
	"starDisplayName_one": "{{count}} star ({{total}})",
	"starDisplayName_other": "{{count}} stars ({{total}})",
	"starRating": "Star Rating",
	"title": "Select photos to edit"
}
